// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"a4b18674","139":"6f0c5619","467":"79c99802","806":"09b27276","866":"fc9d1e5a"}[chunkId] + ".chunk.js";
};